export const BilletActions = Object.freeze({
  CONFIRM_PAYMENT: 'CONFIRM_PAYMENT',
  CANCEL: 'CANCEL',
  EXCLUDE: 'EXCLUDE',
  UPDATE_DUE_OR_VALUE: 'UPDATE_DUE_OR_VALUE',
  SETTLE: 'SETTLE',
});


export const BilletStatuses = Object.freeze({
  OPEN: 'ABERTO',
  PAID: 'BAIXADO',
  PAID_WITH_PENDING: 'BAIXADO COM PENDÊNCIA',
  CANCELED: 'CANCELADO',
  DELETED: 'EXCLUIDO',
  SETTLED: 'LIQUIDADO',
});
